import { render, staticRenderFns } from "./riskCockpit.vue?vue&type=template&id=f138889e&scoped=true&"
import script from "./riskCockpit.vue?vue&type=script&lang=js&"
export * from "./riskCockpit.vue?vue&type=script&lang=js&"
import style0 from "./riskCockpit.vue?vue&type=style&index=0&id=f138889e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f138889e",
  null
  
)

export default component.exports